import React, { useEffect, useState } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Cell } from 'recharts';
import { db } from '../Firebase';
import { collection, getDocs } from 'firebase/firestore';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28'];

export default function TransparencyDashboardPage() {
  const [load, setLoad] = useState(false);
  const [allUsers, setAllUsers] = useState([]);
  const [allHubs, setAllHubs] = useState([]);
  const [reachData, setReachData] = useState([]); // 👈 for dynamic chart

  const dashboardData = {
    downloads: [
      { name: 'Farming Guide', value: 12 },
      { name: 'Nutrition Guide', value: 20 },
      { name: 'Budget Planner', value: 17 },
    ],
    guidesDownloaded: 49,
  };

  useEffect(() => {
    const fetchAllUsers = async () => {
      setLoad(true);
      try {
        const querySnapshot = await getDocs(collection(db, 'users'));
        const docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAllUsers(docs);

        const countryMap = {};
        docs.forEach(user => {
          const country = user.place || "Unknown";
          
          countryMap[country] = (countryMap[country] || 0) + 1;
        });

        // convert to array
        let countryArray = Object.entries(countryMap).map(([name, households]) => ({ name, households }));

        // sort by households DESC
        countryArray.sort((a, b) => b.households - a.households);
        // take top 5
        countryArray = countryArray.slice(0, 5);

        setReachData(countryArray);

      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoad(false);
      }
    };

    const fetchAllHubs = async () => {
      setLoad(true);
      try {
        const querySnapshotHub = await getDocs(collection(db, 'hubs'));
        const docs = querySnapshotHub.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAllHubs(docs);

       
        
      } catch (err) {
        console.error("Error fetching hubs:", err);
      } finally {
        setLoad(false);
      }
    };

    fetchAllUsers();
    fetchAllHubs();
  }, []);

  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-2">Transparency Dashboard</h1>
      <p className="text-center text-gray-600 mb-10">Our impact, powered by your participation.</p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md text-center border">
          <h3 className="text-4xl font-bold text-green-600">{allUsers.length}</h3>
          <p className="text-gray-600 mt-2">Households Reached</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md text-center border">
          <h3 className="text-4xl font-bold text-green-600">{allHubs.length}</h3>
          <p className="text-gray-600 mt-2">Total Local Hubs</p>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md text-center border">
          <h3 className="text-4xl font-bold text-green-600">{dashboardData.guidesDownloaded.toLocaleString()}</h3>
          <p className="text-gray-600 mt-2">Guides Downloaded</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* ✅ Dynamic BarChart */}
        <div className="bg-white p-6 rounded-lg shadow-md border">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Households Reached by Country</h2>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <BarChart data={reachData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="households" fill="#10B981" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie Chart */}
        <div className="bg-white p-6 rounded-lg shadow-md border">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Resource Downloads by Type</h2>
          <div style={{ width: '100%', height: 300 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={dashboardData.downloads}
                  cx="50%" cy="50%"
                  labelLine={false}
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                  nameKey="name"
                  label
                >
                  {dashboardData.downloads.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
